import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { CircularProgress, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@mui/material';
import { getLocaleDateTime, getUserFullName, getVoteStatus } from 'app/utils/appHelpers';
import { dshCardScrollHeight, dshCardScrollHeightV2, greenColor, redColor } from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import '../styles/customComponentCss.css';
import { getObjectByIdApi } from 'api/general';
import { MEETINGS } from 'app/utils/constants/customConstant';

function DashboardVoteListTable({ agendaVotes, setVoteInputStatus, otherScroll = 'false', type = 'dashboard' }) {

  const [loading, setLoading] = useState(false);
  const userList = useSelector((state) => state.user.data);
  const [meetingUsers, setMeetingUsers] = useState([]);
  const [resultMessage, setResultMessage] = useState();
  

  const [acceptCount, setAcceptCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [unvotedCount, setUnvotedCount] = useState(0);
  const [processedUsers, setProcessedUsers] = useState([]);
  const [voteStatusInfo, setVoteStatusInfo] = useState("");

  const currentMeetingUsers = useSelector((state) => state.meeting.currentMeetingUsers);

  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);

  useEffect(() => {
    const getAPI = async () => {
      try {

        if (!processedUsers.length) {
          setLoading(true)
        }

        if (currentMeeting && Object.keys(currentMeeting).length > 0 && currentMeeting.statVote === 1 && currentMeeting.statFinish !== 1) {
          setVoteStatusInfo("Mevcut oy durumu aşağıdaki gibidir: ");
        }

        if (type === 'dstatusCard') {

          if (currentMeetingUsers && currentMeetingUsers.length > 0) {
            const result = await getObjectByIdApi(MEETINGS, currentMeetingUsers[0].meetingId);
            const data = result.data;
            if (result.status) {
              if (data !== undefined) {
                if (data.statFinish !== 1 && data.statVote === 1) {
                  setVoteStatusInfo("Mevcut oy durumu aşağıdaki gibidir: ");
                }
              }
            }
          }
        }
        const result = await getVoteStatus(currentMeetingUsers, agendaVotes, userList, currentMeeting);
        setProcessedUsers(result.processedUsers);
        setAcceptCount(result.acceptCount);
        setRejectCount(result.rejectCount);
        setUnvotedCount(result.unvotedCount);
        setResultMessage(result.voteResultType.text);

      } catch (err) {
        // console.log('Hata:', err)
      } finally {
        if (setVoteInputStatus) {
          setVoteInputStatus(false)
        }

        setLoading(false);
      }

    };
    getAPI();
    // }, [agendaVotes, setVoteInputStatus]);

  }, [meetingUsers, agendaVotes, userList, setVoteInputStatus]);

  const containerStyles = {
    position: 'relative',
    height: otherScroll === 'none' ? 'auto' : `${dshCardScrollHeight}`
  };

  const renderVoteIcon = (user) => {
    const voteObj = user.voteObj;
    // if (user.user === undefined) {
    //   if (voteObj && voteObj.vote === 1) return <span style={{  }}>Kabul</span>;
    //   if (voteObj && voteObj.vote === 2) return <span style={{  }}>Ret</span>;
    //   return <span style={{  }}>Henüz oy verilmedi</span>;
    // }
    // Eğer kullanıcı bilgisi varsa ikon gösterimi
    if (voteObj && voteObj.vote === 1) return <ThumbUpIcon style={{ color: '#3BD2A2' }} />;
    if (voteObj && voteObj.vote === 2) return <ThumbDownIcon style={{ color: '#E73146' }} />;
    return <span style={{  }}>Henüz oy verilmedi</span>;
  };

  const styles = {
    position: 'relative',
    height: `${dshCardScrollHeight}`
  }

  return (
    <div style={containerStyles}>
      <Table style={{ margin: 0, padding: 0, lineHeight: 1 }} size="small" className="small-font-table">
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "30%", paddingBottom: 0, paddingTop: 0, paddingLeft: 5 }}>
              Üye
            </TableCell>
            <TableCell style={{ width: "30%", paddingBottom: 0, paddingTop: 0 }}>
              Oy
            </TableCell>
            <TableCell
              sx={{
                minWidth: "100px",
                maxWidth: "100px",
                paddingBottom: 0,
                paddingTop: 0,
                width: "40%"
              }}
            >
              Gerekçe/Tarih
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>

      {otherScroll === 'false' ? (
        <JumboScrollbar
          autoHeight
          autoHeightMin={`${dshCardScrollHeightV2}`}
          autoHide
          autoHideDuration={200}
          autoHideTimeout={500}
        >
          <Table style={{ margin: 0, padding: 0, tableLayout: 'auto', lineHeight: 1 }} size="small">
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress style={{  }} />
                  </TableCell>
                </TableRow>
              ) : processedUsers && processedUsers.length > 0 ? (
                processedUsers.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ width: "30%", paddingBottom: 0, paddingTop: 2, paddingLeft: 5 }}>
                      {getUserFullName(item.user)}
                      <span style={{ display: "block", marginTop: "5px", fontStyle: "italic", color: "#8595A6" }}>
                        {item.inst || ""}
                      </span>
                      {item.memberRole === "Başkan" || item.memberRole === "Başkan Yrd" ? (
                        <span style={{ fontStyle: "italic" }}>{" "}  ({item.memberRole})</span>
                      ) : null}
                      {item.acting === "Vekaleten" ? (
                        <span style={{ fontStyle: "italic" }}>{" "}  (V.)</span>
                      ) : null}
                      {item.attendanceStatus === 0 || item.attendanceStatus === '0' ? (
                        <span style={{ fontStyle: "italic" }}>{" "}  ({"Katılmadı"})</span>
                      ) : null}
                    </TableCell>
                    <TableCell style={{ width: "25%" }}>
                      {renderVoteIcon(item)}
                    </TableCell>
                    <TableCell
                      sx={{
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        minWidth: "100px",
                        maxWidth: "100px",
                        width: "45%"
                      }}
                    >
                      {item.voteObj ? item.voteObj.info : ""}
                      <span style={{ display: "block", fontStyle: "italic", color: "#8595A6" }}>
                        {item.voteObj ? getLocaleDateTime(item.voteObj.pdate) : ""}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center" style={{  }}>
                    Katılımcı yorumu bulunmamaktadır
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </JumboScrollbar>
      ) : (
        <Table style={{ margin: 0, padding: 0, tableLayout: 'auto', lineHeight: 1 }} size="small">
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <CircularProgress style={{  }} />
                </TableCell>
              </TableRow>
            ) : processedUsers && processedUsers.length > 0 ? (
              processedUsers.map((item, index) => (
                <TableRow key={index}>
                  <TableCell style={{ width: "30%", paddingBottom: 0, paddingTop: 2, paddingLeft: 5 }}>
                    {getUserFullName(item.user)}{" "}
                    <span style={{ fontStyle: "italic" }}>({item.inst || ""})</span>
                    {item.memberRole === "Başkan" || item.memberRole === "Başkan Yrd" ? (
                      <span style={{ fontStyle: "italic" }}>{" "}  ({item.memberRole})</span>
                    ) : null}
                    {item.acting === "Vekaleten" ? (
                      <span style={{ fontStyle: "italic" }}>{" "}  (V.)</span>
                    ) : null}
                    {item.attendanceStatus === 0 || item.attendanceStatus === '0' ? (
                      <span style={{ fontStyle: "italic" }}>{" "}  ({"Katılmadı"})</span>
                    ) : null}
                  </TableCell>
                  <TableCell style={{ width: "30%" }}>
                    {renderVoteIcon(item)}
                  </TableCell>
                  <TableCell
                    sx={{
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      minWidth: "100px",
                      maxWidth: "100px",
                      width: "40%"
                    }}
                  >
                    {item.voteObj ? item.voteObj.info : ""}
                    <span style={{ display: "block", fontStyle: "italic", color: "#8595A6" }}>
                      {item.voteObj ? getLocaleDateTime(item.voteObj.pdate) : ""}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center" style={{  }}>
                  Toplantıya üye eklenmemiştir
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}

      {/* Sabit Footer */}
      <Table style={{ margin: 0, padding: 0, lineHeight: 1 }} size="small">
        <TableFooter>
          <TableCell colSpan={3} align="center" style={{ border: 'none', height: '20px' }}>
            <p style={{ margin: 0, padding: 0 }}>
              <span>{`Kabul: `}</span>
              <span style={{ color: greenColor }}>{acceptCount}</span>
              <span>{` Ret: `}</span>
              <span style={{ color: redColor }}>{rejectCount}</span>
              <span>{` Kullanılmayan: `}</span>
              <span>{unvotedCount}</span>
              <br />
              {voteStatusInfo !== "" && (
                <>
                  <span> {voteStatusInfo} </span>
                  <br />
                </>

              )}

              <span> {resultMessage}</span>
            </p>
          </TableCell>
        </TableFooter>
      </Table>
    </div>
  );
}

export default DashboardVoteListTable;